"use client";

import { useCallback } from "react";
import { useClerk } from "@clerk/nextjs";
import { isNativeCapacitorApp } from "@/lib/client/capacitor";
import { NativeClerk, configureNativeClerk } from "@/lib/client/nativeClerk";
import { syncNativeClerkSession } from "@/lib/client/nativeClerkSession";

export function useNativeSignIn() {
  const clerk = useClerk();

  const openSignIn = useCallback(async () => {
    if (!isNativeCapacitorApp()) {
      clerk.openSignIn();
      return;
    }

    await configureNativeClerk();
    await NativeClerk.startHostedAuth();
    await syncNativeClerkSession(clerk);
  }, [clerk]);

  return { openSignIn };
}
